<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card>
      <b-card-title
        class="fs-32 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <span>Parcelamento cartão</span>
        </div>
      </b-card-title>
      <b-card-text>
        <span
          >Escolha abaixo as parcelas e os valores que deseja liberar para seus
          clientes:</span
        >
        <h4>
          <b-badge variant="warning">O juros da parcela inserida na quantidade de mês, será o juros total somado ao valor do pedido</b-badge>
        </h4>
        <b-row class="mt-4 container">
          <b-table 
            v-if="table.records.length > 0"
            responsive
            fixed
            small
            borderless
            :fields="table.headers"
            :items="table.records"
          >
            <template #cell(enable)="data">
              <b-form-checkbox
                switch
                @change="showModalDelete(table.records[data.item.parcel-2].id, data.item.parcel)"
                v-model="table.records[data.item.parcel-2].enabled"
                :disabled="whatClerkPermission()"
              />
            </template>

            <template #cell(value)="data">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">R$</span>
                </div>
                <input
                  class="form-control"
                  type="number"
                  v-mask="['#', '##', '###', '####', '#####', '######', '#######', '########']"
                  aria-describedby="basic-addon1"
                  v-model="table.records[data.item.parcel - 2].value"
                  :disabled="!table.records[data.item.parcel - 2]"
                />
              </div>
            </template>
            <template #cell(tax)="data">
              <div v-if="hasTax[data.item.parcel-2]" class="input-group">
                <input
                  class="form-control"
                  type="number"
                  v-mask="['#', '#.#', '##.#', '##.##']"
                  aria-describedby="basic-addon1"
                  v-model="table.records[data.item.parcel-2].tax"
                  />
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">%</span>
                  </div>
              </div>
              <b-button
                v-else
                variant="outline-info"
                @click="addTax(`${data.item.parcel}`- 2)"
                style="width: 120px;"
              >  Adicionar Juros</b-button>
            </template>
            <template #cell(action)="data">    
              <button
                class="btn btn-success width-button"
                @click="saveParcel(data.item.parcel)"
              >
                Salvar
              </button>
            </template>
            <template #cell(parcel)="data">
              <span>
                {{ data.item.parcel }}
              </span>
            </template>
          </b-table>
        </b-row>
        <b-row no-gutters>
          <b-button
            v-if="table.records.length < 11"
            :disabled="!isSave"
            @click="addParcel()" 
            variant="primary"
          >Adicionar Parcela</b-button>
        </b-row>
        <b-row>** Para adicionar a próxima parcela precisa salvar a atual</b-row>
      </b-card-text>
    </b-card>

    <b-modal 
      v-model="modalShow"
      title="Excluir parcela"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      centered
      header-bg-variant="orange"
      header-text-variant="light"
      :busy="loading"
      ok-title="Fechar"
      ok-variant="danger"
    >
      <div class="d-flex justify-content-center">
        <span class="fs-20">Tem certeza que deseja excluir a parcela {{ parcelDelete }} ?</span>
      </div>

      <div class="d-flex justify-content-center mt-4 mb-2">
        <b-button @click="hideModalDelete()" variant="outline-warning" class="mr-5">Cancelar</b-button>
        <b-button @click="deleteParcel(idDelete, parcelDelete)" variant="danger">Excluir</b-button>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '../../../mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';

export default {
  name: 'InstallmentsCard',
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      isSave: false,
      modalShow: false,
      idDelete: "",
      parcelDelete: "",
      hasTax: [],
      table: {
        headers: [
          {
            key: 'enable',
            label: 'Habilitar',
            sortable: false,
            thStyle: 'width: 50px;',
          },
          {
            key: 'parcel',
            label: 'Parcela',
            sortable: false,
            thStyle: 'width: 60px;',
          },
          {
            key: 'value',
            label: 'A partir de ',
            sortable: false,
            thStyle: 'width: 120px;',
          },
          {
            key: 'tax',
            label: 'Taxa de Juros ',
            sortable: false,
            thStyle: 'width: 120px;',
          },
          {
            key: 'action',
            label: 'Ações',
            sortable: false,
            thStyle: 'width: 320px;',
          },
        ],
        records: [],
      },
    };
  },

  mounted() {
    this.getParcel();
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    ...mapActions('shopkeeper', [
      'savePaymentCredit',
      'getPaymentCredit',
      'deletePaymentCredit',
    ]),

    verify(value, parcel, index) {
      if (this.checkIsEmpty(value) || value === 0) {
        this.makeToast(
          'Erro',
          'O campo esta desabilitado, vazio ou zerado',
          'danger'
        );
        return false;
      }

      if(parcel > 2) {
        if(!this.checkIsEmpty(this.table.records[index - 1]) && parseInt(this.table.records[index -1].value) > parseInt(value)){
          this.makeToast(
            'Erro',
            'O valor dessa parcela tem que ser maior ou igual as anteriores',
            'danger'
          );
          return false;
        }
      }

      if((parcel > 2 && parcel < 12)) {
        if(!this.checkIsEmpty(this.table.records[index + 1]) && parseInt(this.table.records[index + 1].value) < parseInt(value)){
          this.makeToast(
            'Erro',
            'O valor dessa parcela tem que ser menor ou igual a posterior',
            'danger'
          );
          return false;
        }
      }
      return true;
    },

    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined' ||
        value === undefined
      ) {
        return true;
      }
      return false;
    },

    showModalDelete(id ="", parcel){
      this.modalShow = !this.modalShow;
      this.parcelDelete = parcel;
      this.idDelete = id;
    },

    hideModalDelete(){
      this.modalShow = !this.modalShow;
      this.table.records[this.parcelDelete-2].enabled = true;
    },

    addParcel() {
      const isEmpty  = this.table.records.some((x)=> x.value === null || x.value === "");
      if(isEmpty) {
        this.makeToast(
          "Erro",
          "Existe algum campo vazio, favor corrigir",
          "danger"
        )
        return
      }

      this.table.records.push(
        {
          "id": "",
          "parcel": this.table.records.length + 2,
          "value": "",
          "enabled": true,
          "tax": "",
        }
      )
      this.isSave = false;
    },
    getParcel() {
      this.isSave = true;
      this.$store.dispatch('startLoader');
      this.getPaymentCredit(this.dadosUsuario.id)
        .then((response) => {
          this.table.records = response.data.data;

          this.table.records.forEach((item, index) => {
             const isTax = item.tax ? true: false;
             this.hasTax.push(isTax);
          });
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os valores das parcelas',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    addTax(index) {
      this.$set(this.hasTax, index, true);
    },
    saveParcel(parcelCredit) {
      const index = parcelCredit - 2;
      const dataParcel = {
        construp_user_id: this.dadosUsuario.id,
        id: this.table.records[index].id ? this.table.records[index].id : "",
        parcel: parcelCredit,
        value: this.table.records[index].value,
        tax: this.table.records[index].tax ? this.table.records[index].tax : 0,
      }; 
      
      if(!this.verify(dataParcel.value, parcelCredit, index)) return
      
      this.$store.dispatch('startLoader');
      this.savePaymentCredit(dataParcel)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Parcelas Salvas com sucesso!',
            'success'
          );
          this.isSave = true;
          this.getParcel();
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao salvar os valores das parcelas',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    deleteParcel(id, parcel) {
      this.modalShow = !this.modalShow;
      const index = parcel - 2;
      
      if (this.checkIsEmpty(id)) return;
      if(this.checkIsEmpty(this.table.records[index].value)) return;
      
      if((parcel >= 2 && parcel < 12) && !this.checkIsEmpty(this.table.records[index + 1])) {
        this.table.records[index].enabled = true;
        this.makeToast(
          'Erro',
          'Você precisa deletar a parcela posterior primeiro!',
          'danger'
        );
        return;
      }
  
      this.$store.dispatch('startLoader');
        this.deletePaymentCredit(id)
        .then((response) => {
          if (response) {
            this.makeToast(
              'Sucesso',
              'Parcela deletado com sucesso!',
              'success'
            );
            this.getParcel();
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao salvar os meios de pagamentos, tente novamente!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    whatClerkPermission() {
      if (this.$route.meta.userType === UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name === NamePermission.MEIO_PAGAMENTO
        );

        if (
          this.$route.meta.userType === UserTypes.BALCONISTA &&
          permission.type === TypePermission.BALCONISTA
        ) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>
.toggle {
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  border: 1px solid #adb5bd;
  border-radius: 16px;
  width: 36px;
  height: 19px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
  content: '';
}
.toggle-switch:before {
  display: block;
  background: #adb5bd;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 13px;
  height: 13px;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: left 0.25s;
}
.toggle:hover .toggle-switch:before {
  background: #adb5bd;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
.toggle-checkbox:checked + .toggle-switch {
  background: #007bff;
}
.toggle-checkbox:checked + .toggle-switch:before {
  left: 20px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}
.width-button{
  width: 100px;
}
</style>